import { buildManageSections } from '@repo/config/Global';

export * from '@repo/config/Global';

// TAP has no manage surface of its own yet; this value is referenced by the
// shared @repo/stores/NavigationStore but never read in any TAP route.
export const manageSections = buildManageSections('/manage');
